module.exports = __webpack_public_path__ + "img/0Q3A8493_L_Foamcore_MockedUp.4642a4a4.jpg";